import {SearchServiceOrdersFilter} from './search-service-orders-filter';

export class SearchServiceOrdersRequestBody {
  resultPartition?: number;
  searchFilter: SearchServiceOrdersFilter;
}
